export default {
  "ORDER_WAIT_SHIP": "Menunggu penghantaran",
  "Men fashion": "Pakaian lelaki",
  "Shipping_details": "Alamat penghantaran",
  "MyAccount_MyProfile_label_First": "Nama",
  "MyAccount_MyShippingDetails_Phone": "Nombor telefon",
  "Page_not_found_message1": "Maaf, laman tidak ditemui",
  "Help": "Bantuan",
  "Sign in": "Log masuk",
  "Register": "Daftar",
  "Category_sorting_Item": "Pilih cara penyusunan",
  "cart_clear": "Kosongkan troli",
  "Payment & Delivery": "Bayaran dan penghantaran",
  "Send my feedback": "Kirim maklum balas saya",
  "MyAccount_MyProfile_Save": "Simpan perubahan",
  "Continue_billing": "Teruskan belian",
  "Categories": "Kategori",
  "Read and understand": "Saya telah membaca dan memahami",
  "Feel free to edit": "Edit butiran anda pada bila-bila masa supaya akaun anda sentiasa dikemaskini",
  "Select payment method": "Pilih cara pembayaran",
  "cartPreviewSafety_messageinfo": "Penghantaran selamat dan pantas kepada alamat anda",
  "Login_input_email": "e-mel",
  "Login_input_first": "Nama",
  "Account": "Akaun",
  "Create_Time_Asc": "Masa cipta meningkat",
  "Order_No": "Nombor pesanan",
  "MyAccount_Newsletter": "Surat berita",
  "concactus_label": "Cadangan atau soalan",
  "Order_Grade": "Penarafan pesanan",
  "wishlist_empty_desc": "Nampaknya anda masih belum menambah sebarang produk ke dalam senarai hajat anda",
  "cartpreviewShipping_messageinfo": "Anda akan menerima pengesahan penghantaran dan tarikh penerimaan",
  "unsubscribe": "Anda boleh berhenti berlangganan pada bila-bila masa",
  "prompt": "Panduan",
  "MyAccount_MyProfile_yinsi_message": "Di Brand name, kami memberi tumpuan kepada isu privasi dan berusaha untuk melindungi data peribadi pengguna. Untuk maklumat lanjut mengenai bagaimana kami mengendalikan dan menggunakan data peribadi anda, sila rujuk",
  "About us": "Tentang kami",
  "or": "atau",
  "MyAccount_Order_History_All": "Semua pesanan",
  "What_We_Improve": "Bagaimana kami boleh memperbaiki?",
  "MyAccount_ShippingDetails_title": "Butiran penghantaran",
  "MyAccount_Order_History_Tabs2": "Menunggu pembayaran",
  "Go_back_shopping": "Kembali ke membeli-belah",
  "Product": "Produk",
  "Order summary": "Ringkasan pesanan",
  "payment_order_total": "Jumlah pesanan",
  "Departments": "Pernyataan undang-undang",
  "Download": "Muat turun",
  "Your_Purchase_Order": "Pesanan pembelian anda",
  "Your_Account": "Akaun anda",
  "order_after_sales_list_null": "Anda tidak mempunyai sebarang pesanan selepas penjualan buat masa ini",
  "All_After_sales_orders": "Semua pesanan selepas jualan",
  "Filters": "Penapis",
  "search_results_not": "Kami tidak dapat mencari hasil yang berkaitan dengan frasa yang diberikan",
  "ORDER_WAIT_RECEIPT": "Menunggu penerimaan",
  "ORDER_CLOSED": "Ditutup",
  "Order_View_details": "Lihat butiran",
  "Subscribe_to_message": "Ketahui tentang jualan dan acara yang akan datang. Dapatkan hadiah dan tawaran istimewa!",
  "TaxFee": "Cukai dan yuran",
  "Apply": "Memohon",
  "Total_price": "Jumlah harga",
  "Description": "Penerangan",
  "Payment method": "Cara bayaran",
  "Back": "Kembali",
  "Empty": "Nampaknya anda belum menambah apa-apa produk ke dalam troli anda. Mulakan membeli-belah untuk mengisi ia.",
  "After_sales": "Selepas jualan",
  "Instruction3": "Ya, kami faham",
  "MyAccount_MyShippingDetails_Last": "Nama keluarga",
  "MyAccount_MyShippingDetails_City": "Bandar",
  "payment_order_discount": "Diskaun pesanan",
  "MyAccount_Order": "Butiran pesanan",
  "ID_Name_Error": "Sila masukkan nama kad pengenalan anda",
  "Kidswear": "Pakaian kanak-kanak",
  "Share your look": "Kongsi penampilan anda",
  "Pay_Order": "Bayar pesanan",
  "Reset_Password": "Tetapkan semula kata laluan",
  "MyAccount_MyProfile_label2_pass1": "Kata laluan terkini",
  "Create_Time_Desc": "Masa dicipta menurun",
  "Items": "Barang",
  "Login_Register": "Daftar sekarang",
  "Back to homepage": "Kembali ke halaman utama",
  "switch_CNY": "Tukar kepada Ringgit",
  "Successful placed order": "Pesanan anda telah berjaya ditempatkan. Anda boleh menggunakan fungsi status penghantaran kami untuk memeriksa status pesanan anda. Anda akan menerima e-mel pengesahan pesanan yang mengandungi butiran pesanan dan pautan jejak. ",
  "MyAccount_MyProfile_yinsi_link": "Dasar privasi",
  "Order_Date": "Tarikh pesanan",
  "Allow order notifications": "Benarkan pemberitahuan pesanan",
  "MyAccount_MyProfile_Tab1": "Butiran peribadi",
  "MyAccount_ShippingDetails_changeTitle": "Ubah alamat",
  "ID_Number": "Nombor kad pengenalan",
  "Order_after_sales_message": "Butiran pesanan dan selepas jualan",
  "MyAccount_MyProfile_title2": "Jika anda ingin menukar kata laluan yang digunakan untuk mengakses akaun anda, sila masukkan maklumat berikut:",
  "cartPreviewSafety": "Penghantaran selamat",
  "Customer service": "Perkhidmatan pelanggan",
  "MyAccount_MyProfile_Update": "Kemas kini kata laluan",
  "choose_language": "Pilih bahasa",
  "ORDER_REFUNDING": "Pengembalian wang sedang diproses",
  "MyAccount_MyProfile_title1": "Edit butiran berikut pada bila-bila masa supaya akaun anda sentiasa terkini",
  "ORDER_WAIT_RATE": "Menunggu penilaian",
  "after_sales_refund_order": "Pengembalian wang pesanan",
  "Who we are": "Kami adalah siapa",
  "Women fashion": "Fesyen wanita",
  "Personal details": "Butiran peribadi",
  "Password": "Kata laluan",
  "wishlist_empty_title": "Senarai hasrat anda kosong",
  "Shipping": "Penghantaran",
  "Repeat_Password": "Ulang kata laluan",
  "cart_price": "Jumlah kecil",
  "Sort_by": "Susun mengikut",
  "Customer Reviews": "Ulasan pelanggan",
  "Continue to shipping": "Teruskan ke penghantaran",
  "payment_make_order": "Buat pesanan",
  "MyAccount_Profile": "Profil",
  "MyAccount_Wishlist": "Senarai hasrat",
  "save_order_review": "Hantar tinjauan",
  "Save_Password": "Simpan kata laluan",
  "cart_empty_title": "Troli beli-belah anda kosong",
  "TopBar_help": "Bantuan & FAQ",
  "colseCookie": "Saya faham",
  "Password_Changed": "Kata laluan telah berjaya ditukar. Anda boleh kembali ke halaman utama dan log masuk.",
  "Forgot Password Modal Email": "E-mel yang anda gunakan untuk log masuk:",
  "MyAccount_Personal": "Butiran peribadi",
  "cartPreviewShipping": "Penghantaran mudah",
  "ORDER_AFTER_SALE": "Selepas jualan",
  "Page_not_found": "Halaman tidak ditemui",
  "Find out more": "Ketahui lagi lanjut",
  "Log into your account": "Log masuk akaun anda",
  "Details_and_status_orders": "Periksa butiran dan status pesanan anda di kedai dalam talian. Anda juga boleh membatalkan pesanan atau meminta pengembalian wang.",
  "MyAccount_MyShippingDetails_Street": "Jalan",
  "Order_to_be_paid_message": "Pesanan belum dibayar",
  "Guarantee": "Jaminan",
  "Sections that interest you": "Seksyen yang anda minati",
  "payment_post_tax": "Cukai penghantaran",
  "ORDER_PAID": "Dibayar",
  "concactus_label5": "Gelaran",
  "Item": "Item",
  "Go_back": "Kembali",
  "more": "Lagi",
  "MyAccount": "Akaun saya",
  "payment_agree_1": "Saya bersetuju",
  "total_items": "Jumlah item",
  "shopping_go": "Urus alamat penghantaran",
  "ID_Type": "Jenis Kad Pengenalan",
  "MyAccount_MyShippingDetails_HouseNumber": "Nombor rumah",
  "after_sales_status": "Status jualan selepas",
  "After_sales_apply": "Memohon jualan selepas",
  "Login": "Log masuk",
  "Quantity": "Kuantiti",
  "payment_post_fee": "Bayaran pos",
  "MyAccount_Log_out": "Log keluar",
  "Subtotal": "Jumlah kecil",
  "forgotPasswordConfirmation": "Terima kasih! Jika anda mendaftar akaun dengan {0} e-mel, anda akan menemukan Butiran pautan reset kata laluan dalam peti masuk anda.",
  "MyAccount_Order_History_Tabs1": "Sejarah Pesanan Saya",
  "concactus_img": "Unggah Gambar",
  "Done": "Selesai",
  "Info after order": "Anda dapat masuk ke akun Anda dengan email dan kata sandi yang telah Anda tentukan sebelumnya. Di akun Anda, Anda dapat mengedit profil, melihat riwayat transaksi, mengedit langganan berita, dan lain-lain.",
  "MyAccoubnt_Set_newsletter": "Atur langganan berita Anda, kami akan mengirimkan informasi produk baru dan tren yang Anda pilih setiap minggu.",
  "Shipping_method": "Metode Pengiriman",
  "after_sales_refund": "Jumlah Refund",
  "After_sales_save": "Simpan Informasi Layanan Pasca Penjualan",
  "go_order_history": "Lihat Riwayat Pesanan",
  "contactus_message_placeholder": "Tulis komentar atau pertanyaan Anda di sini",
  "Login_Forgot_Password": "Jika Anda lupa kata sandi, Anda bisa mengatur ulang kata sandi Anda.",
  "show_more": "Lihat lebih banyak",
  "MyAccount_MyProfile_label_email": "Email",
  "MyAccount_MyProfile_label2_pass3": "Ulangi Kata Sandi",
  "Products": "Produk",
  "Review": "Ulasan",
  "MyAccount_MyProfile_title3": "Alamat email Anda saat ini adalah",
  "Category_found_Products": "Produk Ditemukan",
  "Match": "Padanan",
  "Read_all_reviews": "Baca semua ulasan",
  "See_all": "Lihat semua",
  "Commercial information": "Saya menyetujui untuk menerima informasi komersial dari {0} melalui email.",
  "Change password your account": "Jika Anda ingin mengubah kata sandi akun akses Anda, silakan masukkan informasi di bawah ini.",
  "MyAccount_History": "Riwayat Pesanan",
  "ID_Name": "Nama Kartu Identitas",
  "All": "Semua",
  "Instruction2": "Hanya Ingin Instruksi Pemeliharaan?",
  "MyAccount_ShippingDetails_Add": "Tambahkan Alamat Baru",
  "MyAccount_MyShippingDetails_Zip": "Kode Pos",
  "go_pay_order": "Bayar Sekarang",
  "Thank_You_Inbox": "Jika pesan tidak muncul di kotak masuk Anda, coba gunakan alamat email lain yang mungkin Anda gunakan untuk mendaftar.",
  "Subscribe": "Berlangganan",
  "confirm_subscription": "Saya mengkonfirmasi bahwa saya ingin berlangganan",
  "Login_input_Remember": "Ingat Saya",
  "Add to compare": "Tambahkan untuk membandingkan",
  "Brand": "Merek",
  "Start_shopping": "Mulai Belanja",
  "Select shipping method": "Pilih Metode Pengiriman",
  "address CN": "Alamat di Cina, mata uang saat ini harus dalam RMB.",
  "MyAccount_MyShippingDetails_State": "Negara/Provinsi",
  "Page_not_found_message2": "Silakan kembali atau coba lagi",
  "Go_to_checkout": "Lanjut ke Pembayaran",
  "See all results": "Lihat semua hasil",
  "search_results_inputnull": "Anda belum mencari produk apa pun.",
  "subscribeToNewsletterModalContent": "Setelah berlangganan, Anda akan menerima penawaran istimewa dan informasi dari VSF melalui email. Kami tidak akan pernah menjual atau mendistribusikan alamat email Anda ke pihak ketiga. Lihat kebijakan privasi kami untuk informasi selengkapnya{0}.",
  "Download all": "Unduh Semua",
  "Login_input_last": "Nama Belakang",
  "Amount": "Jumlah",
  "ORDER_WAIT_PAYMENT": "Menunggu Pembayaran",
  "Order_After_sales": "Selepas Jualan Pesanan",
  "concattus_button": "Hantar",
  "Shipping_valid_required": "Ruangan ini diperlukan",
  "Price": "Harga",
  "Search_items": "Cari",
  "ID_Type_Error": "Sila pilih jenis kad pengenalan anda",
  "Order_Status": "Status Pesanan",
  "Payment methods": "Cara Pembayaran",
  "MyAccount_MyProfile_Tab2": "Ubah Katalaluan",
  "Show on page": "Paparkan di laman web",
  "Edit": "Sunting",
  "Change": "Tukar",
  "MyAccount_ShippingDetails_Update": "Kemaskini Alamat",
  "View": "Lihat",
  "Privacy": "Privasi",
  "Enter_promo_code": "Masukkan Kod Promosi",
  "Discount": "Diskaun",
  "Delete": "Padam",
  "Wishlist": "Senarai Keinginan",
  "MyAccount_Order_History_Tabs3": "Pulangan",
  "Go_To_Order_review": "Ke Ulasan",
  "Update personal data": "Kemaskini Data Peribadi",
  "payment_agree_2": "Terma & Syarat",
  "or fill the details below": "Atau isikan butiran di bawah ini",
  "Contact details updated": "Kemaskini alamat dan butiran kenalan anda tetap terkini.",
  "Login_Create": "Cipta Akaun",
  "Payment": "Bayaran",
  "Billing": "Bil",
  "payment_insurance_tax": "Cukai Insurans",
  "Size guide": "Panduan Saiz",
  "Login_forgotten_password": "Lupa Katalaluan?",
  "Login_no_account": "Tiada akaun?",
  "Privacy_Policy": "Polisi Privasi",
  "BootomCookieTitle": "Kebenaran Kuki",
  "Use your personal data": "Di Brand name, kami mengambil berat tentang privasi dan melindungi data peribadi pengguna kami. Untuk maklumat lanjut tentang bagaimana kami mengambil berat dan menggunakan data peribadi anda, sila rujuk",
  "Review my order": "Semak Pesanan Saya",
  "BootomCookieLink": "Maklumat lanjut",
  "hide": "Sorokkan",
  "MyAccount_ShippingDetails_message_title": "Urus semua alamat penghantaran yang anda inginkan (tempat kerja, rumah, dll.) agar anda tidak perlu memasukkan alamat penghantaran secara manual di setiap pesanan.",
  "Purchase terms": "Terma Pembelian",
  "Billing_address": "Alamat Bil",
  "Manage shipping addresses": "Urus semua alamat penghantaran yang anda inginkan (tempat kerja, rumah, dll.) agar anda tidak perlu memasukkan alamat penghantaran secara manual di setiap pesanan.",
  "login_logbtn": "Log Masuk",
  "choose_currency": "Pilih Mata Wang",
  "ORDER_REFUNDED": "Dikembalikan",
  "After_sales_form": "Isi Borang Selepas Jualan",
  "add_To_Wishlist": "Tambah ke Senarai Keinginan",
  "search_results_inputnull2": "Mula sekarang, kami akan membantu anda",
  "Shipping_title": "Alamat Penghantaran",
  "Total": "Jumlah",
  "Subscribe_to_newsletter": "Langgan buletin",
  "Shipping_valid_Phone": "Sila masukkan nombor telefon yang sah",
  "concactus_label3": "Tajuk",
  "Manage billing addresses": "Urus semua alamat bil anda yang diingini (tempat kerja, rumah, dll.) supaya anda tidak perlu memasukkan alamat bil bagi setiap pesanan. ",
  "Search_results_title": "Keputusan carian",
  "payment_order_payment": "Bayaran pesanan",
  "after_sales_Id": "ID Jualan selepas layanan",
  "cart_title": "Troli saya",
  "Order_Detail": "Butiran pesanan",
  "concactus_label2": "Pautan kedai",
  "Shipping_valid_length_min": "Bidang ini mesti mempunyai sekurang-kurangnya {min} aksara",
  "Product suggestions": "Cadangan produk",
  "Return_home": "Kembali ke laman utama",
  "Quality in the details": "Kualiti terperinci",
  "Continue_to_payment": "Teruskan pembayaran",
  "Feedback": "Maklum balas anda adalah penting untuk kami. Sila beritahu kami apa yang kami boleh perbaiki. ",
  "Go back to shop": "Kembali ke kedai",
  "Back_to_home": "Kembali ke laman utama",
  "Review_Content": "Kandungan kajian",
  "add_To_Cart": "Tambahkan ke troli",
  "Read_reviews": "Baca ulasan",
  "Instruction1": "Cara Penjagaan",
  "Email_address": "Alamat emel",
  "Category_Item_List": "Tukar ke paparan senarai",
  "Same as shipping address": "Sama dengan alamat penghantaran",
  "Category_Item_Grid": "Tukar ke paparan grid",
  "ID_Number_Error": "Sila masukkan nombor kad pengenalan anda ",
  "concactus_label4": "Emel perhubungan",
  "Additional_info": "Maklumat tambahan",
  "add_shipping": "Tambahkan alamat penghantaran baharu",
  "Product_description": "Karissa V-Neck Tee reka bentuk separuh memanjang sesuai untuk pelbagai bentuk badan. Ia melekat erat ke atas kontur dan melindungi kawasan yang biasa menjadi masalah. Ini dilengkapi dengan gaun koktail wanita yang menakjubkan dan gaun parti.",
  "Login_create_account": "Setuju dengan Terma dan Polisi Privasi",
  "after_sales_Reason": "Sebab Jualan selepas Layanan",
  "MyAccount_MyProfile_label_Last": "Nama keluarga",
  "MyAccount_MyProfile_label2_pass2": "Kata laluan baru",
  "Save": "Simpan",
  "CartSliderTextBtn": "Simpan untuk beli kemudian",
  "Color": "Warna",
  "Shipping_Tax": "Cukai Penghantaran",
  "Subscribe_to_success": "Anda telah melanggan",
  "Enjoy your free account": "Nikmati keistimewaan akaun percuma anda!",
  "cart_empty_desc": "Nampaknya anda belum menambah sebarang produk ke troli. Mulakan membeli-belah untuk mengisinya. ",
  "MyAccount_ShippingDetails_message_title2": "Pastikan alamat dan maklumat perhubungan anda dikemaskini. ",
  "An_error_occured": "Ralat berlaku",
  "Country": "Negara/ Kawasan",
  "MyAccount_MyShippingDetails_First": "Nama pertama",
  "payment_insurance_fee": "Bayaran insurans",
  "Home": "Laman utama",
  "Contact_us": "Hubungi kami",
  "Cookies Policy": "Dasar Kuki",
  "match_goods": "Barang Terlaris",
  "Clear all": "Kosongkan Semua",
  "Basket": "Troli Beli-belah",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Kata Laluan Baru Tidak Sama",
  "Your current email address is": "Alamat e-mel anda semasa ini ialah",
  "You currently have no orders": "Anda saat ini tidak mempunyai pesanan",
  "Login_input_password": "Kata Laluan",
  "Promo_code": "Kod Promosi",
  "order_count": "Jumlah Pesanan",
  "email_geshi_error": "Sila masukkan alamat e-mel yang sah",
  "your_email": "E-mel Anda",
  "email": "E-mel",
  "you_have_subscribed": "Anda sudah melanggan",
  "cancel_Subscribe": "Batal Langganan",
  "save_and_pay": "Simpan dan Bayar",
  "hasInsurance": "Sekiranya membeli Insurans",
  "pleasePayType": "Sila Pilih Cara Pembayaran",
  "zhuanfa_toBePay": "Dirujuk ke rakan untuk membayar bagi pihak anda",
  "linkCopied": "Pautan telah disalin, segera pergi dan sentuh-kolek untuk berkongsi dengan rakan-rakan anda",
  "Links": "Pautan",
  "article_category": "Kategori",
  "wechat_code_login_message": "Sila gunakan WeChat untuk mengimbas kod QR untuk log masuk",
  "wechat_code_login": "Log Masuk dengan WeChat",
  "Api_Update_success": "Kemas kini berjaya",
  "Please_Use_WeChat_login": "Sila gunakan WeChat untuk log masuk",
  "mobile_geshi_error": "Sila masukkan nombor telefon yang sah",
  "Login_input_email_required": "Sila masukkan alamat e-mel",
  "article_null": "Tiada Artikel",
  "Login_with_microsoft": "Log Masuk Microsoft",
  "article_null_des": "Anda boleh melayari artikel lain dalam kategori yang berbeza",
  "register_email": "E-mel",
  "Login_tab_email": "E-mel",
  "code.time": "Cuba semula dalam {time} saat",
  "Login_with_wechat": "Log Masuk WeChat",
  "cat_items_null_des": "Anda boleh melayari barang lain dalam kategori yang berbeza",
  "Login_with_facebook": "Log Masuk Facebook",
  "Login_input_code": "Kod Pengesahan",
  "Login_input_mobile_required": "Sila masukkan nombor telefon",
  "Login_input_mobile": "Nombor telefon",
  "cat_items_null": "Tiada barang dalam kategori ini",
  "Login_with_twitter": "Log Masuk Twitter",
  "mobile_code": "Kod Pengesahan",
  "register_mobile": "Telefon",
  "Login_tab_mobile": "Telefon",
  "Login_with_google": "Log Masuk Google",
  "OrderSku": "Spesifikasi Produk",
  "Order_logisticsNo": "Nombor Penghantaran",
  "order_shopping_firstname": "Nama",
  "Order_logisticsName": "Syarikat Penghantaran",
  "ItemPrice": "Jumlah barang",
  "inPayOrderAll": "Daftar tunggu bayar",
  "payPrice": "Jumlah bayaran",
  "shipping_add_success": "Berhasil menambahkan alamat pengiriman",
  "pay_code_refresh": "Segarkan kode pembayaran",
  "pay_code_shixiao": "Kode pembayaran QR sudah kadaluarsa",
  "concactus_title": "Hubungi kami",
  "WebAutoLang": "Bahasa yang disarankan oleh browser saat ini adalah: {lang}. Apakah Anda ingin beralih ke bahasa tersebut?",
  "Services_Name": "Nama layanan",
  "Services_Price": "Harga layanan",
  "SwichLang": "Ubah bahasa",
  "Services_Description": "Deskripsi layanan",
  "goodinfo_null": "Tidak ada barang",
  "goodinfo_null_des": "Anda dapat membrowse kategori lainnya",
  "notYetUseCode": "Kode promo belum digunakan",
  "guest_Login": "Masuk sebagai tamu",
  "billing_and_shipping": "Alamat tagihan dan pengiriman cocok",
  "select_coupon": "Pilih kupon",
  "select_gift": "Pilih hadiah",
  "currentUseCode": "Kode promo sudah digunakan",
  "shipping_refresh": "Segarkan daftar",
  "bind_microsoft": "Ikatkan ke Microsoft",
  "bind_twitter": "Ikatkan ke Twitter",
  "bind_facebook": "Ikatkan ke Facebook",
  "bind_wechat_code": "Kode QR WeChat",
  "bind_wechat": "Ikatkan ke WeChat",
  "bind_google": "Ikatkan ke Google",
  "Wishlist_Empty": "Tidak ada wishlist",
  "discount_post_fee": "Diskon ongkos kirim",
  "ORDER_PART_PAID": "Bayar sebagian",
  "post_state_country": "Ongkir: {country} {state} {postFee} ",
  "discount_kou": "{discount}% off",
  "claimCoupone": "Klaim",
  "claimCouponeSuccess": "Klaim {name} berhasil",
  "Offline_payment": "Pembayaran offline",
  "shopName": "Nama toko",
  "Social": "Sosial",
  "SERVICE": "Layanan",
  "onlineContact": "Hubungi online",
  "confirm": "Konfirmasi",
  "Message": "Pesan",
  "closeOrder": "Batalkan pesanan",
  "Message_Empty_Title": "Pesan kosong",
  "closeOrderContext": "Anda yakin ingin membatalkan pesanan?",
  "MyAccount_Message": "Pesan",
  "Message_Read": "Sudah dibaca",
  "Message_Empty": "Tidak ada pesan",
  "close.order.success": "Pembatalan pesanan berhasil",
  "shippingAddress": "Alamat pengiriman",
  "payment_order_note": "Catatan pesanan",
  "go_to_see_prepid": "Klik di sini untuk melihat pesanan yang belum dibayar",
  "operate": "Operasi",
  "removeCartItemContext": "Anda yakin ingin menghapus {title}？",
  "shippingItemQty": "Jumlah pengiriman",
  "removeCartItem": "Hapus produk",
  "shippingInfo": "Informasi pengiriman",
  "Distributor_success": "Anda telah berhasil menjadi distributor",
  "Distributor_apply": "Daftar menjadi distributor",
  "Distributor_Details": "Distributor",
  "DistributorSataus": "Status",
  "Distributor_Details_Empty": "Tidak ada distributor",
  "distributor.status.4": "Telah dibatalkan",
  "distributor.status.1": "Belum ditinjau",
  "Distributor_copy_url": "Salin tautan distributor",
  "Order_Time": "Waktu pesanan",
  "Order_User": "Pemesan",
  "Distributor_copy_success": "Berhasil disalin",
  "distributor.status.3": "Sudah diselesaikan",
  "MyAccount_Distributor": "Distributor",
  "MyAccoubnt_Set_Distributor": "Mendaftar menjadi distributor",
  "distributor.status.2": "Menunggu penyelesaian",
  "DistributorAmount": "Komisi",
  "Distributor_shenheshibai": "Peninjauan distributor ditolak",
  "Distributor_shenhezhong": "Dalam peninjauan distributor",
  "Distributor_Order_Empty": "Tidak ada pesanan distributor",
  "NE": "Niger",
  "DJ": "Jibuti",
  "KP": "Korea Utara",
  "US": "Amerika Serikat",
  "LC": "Santa Lusia",
  "NL": "Belanda",
  "CD": "Republik Demokratik Kongo",
  "IS": "Islandia",
  "MA": "Maroko",
  "GH": "Ghana",
  "KR": "Korea Selatan",
  "MK": "Makedonia",
  "HT": "Haiti",
  "PF": "Polinesia Prancis",
  "GA": "Gabon",
  "TD": "Chad",
  "LB": "Lebanon",
  "CG": "Kongo",
  "KG": "Kirgistan",
  "TA": "Tristan da Cunha",
  "KW": "Kuwait",
  "TL": "Timor Leste",
  "IN": "India",
  "NO": "Norwegia",
  "NG": "Nigeria",
  "AQ": "Antartika",
  "LY": "Libya",
  "NI": "Nikaragua",
  "TT": "Trinidad dan Tobago",
  "HM": "Kepulauan Heard dan McDonald",
  "PY": "Paraguay",
  "BA": "Bosnia dan Herzegovina",
  "JP": "Jepun",
  "MD": "Moldova",
  "MT": "Malta",
  "RE": "Reunion",
  "UG": "Uganda",
  "SB": "Kepulauan Solomon",
  "SL": "Sierra Leone",
  "CV": "Cape Verde",
  "SD": "Sudan",
  "FO": "Kepulauan Faroe",
  "ZA": "Afrika Selatan",
  "TR": "Turki",
  "FK": "Kepulauan Falkland",
  "PA": "Panama",
  "GF": "Guiana Perancis",
  "TJ": "Tajikistan",
  "NC": "Caledonia Baru",
  "PM": "Saint Pierre dan Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnam",
  "GN": "Guinea",
  "MW": "Malawi",
  "BY": "Belarusia",
  "IM": "Pulau Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Kepulauan Cook",
  "MH": "Kepulauan Marshall",
  "CR": "Costa Rica",
  "HK": "Wilayah Hong Kong SAR China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "Emiriah Arab Bersatu",
  "GI": "Gibraltar",
  "CA": "Kanada",
  "AX": "Kepulauan Aland",
  "UY": "Uruguay",
  "WF": "Wallis dan Futuna",
  "GM": "Gambia",
  "SO": "Somalia",
  "RU": "Rusia",
  "PL": "Poland",
  "FM": "Micronesia",
  "ET": "Ethiopia",
  "EE": "Estonia",
  "SK": "Slovakia",
  "AS": "American Samoa",
  "ZM": "Zambia",
  "AL": "Albania",
  "AT": "Austria",
  "VA": "Vatican City",
  "TW": "Taiwan",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Western Sahara",
  "MO": "Macao SAR China",
  "MV": "Maldives",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chile",
  "IL": "Israel",
  "GD": "Grenada",
  "WS": "Samoa",
  "SE": "Sweden",
  "GP": "Guadeloupe",
  "YE": "Yemen",
  "GT": "Guatemala",
  "BG": "Bulgaria",
  "SJ": "Svalbard and Jan Mayen",
  "CO": "Colombia",
  "LS": "Lesotho",
  "LV": "Latvia",
  "UM": "U.S. Outlying Islands",
  "MX": "Mexico",
  "DO": "Dominican Republic",
  "PE": "Peru",
  "HN": "Honduras",
  "TC": "Turks and Caicos Islands",
  "VI": "U.S. Virgin Islands",
  "FJ": "Fiji",
  "MP": "Northern Mariana Islands",
  "AC": "Ascension Island",
  "NA": "Namibia",
  "SZ": "Eswatini",
  "RW": "Rwanda",
  "BH": "Bahrain",
  "KN": "Saint Kitts and Nevis",
  "TN": "Tunisia",
  "AF": "Afghanistan",
  "VG": "Kepulauan Virgin, British",
  "KE": "Kenya",
  "PK": "Pakistan",
  "GL": "Greenland",
  "SY": "Syria",
  "CU": "Cuba",
  "RS": "Serbia",
  "BF": "Burkina Faso",
  "BM": "Bermuda",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "Cina",
  "MF": "Saint Martin",
  "NF": "Norfolk",
  "MZ": "Mozambique",
  "LU": "Luxembourg",
  "TO": "Tonga",
  "GR": "Yunan",
  "SI": "Slovenia",
  "PW": "Kepulauan Palau",
  "TZ": "Tanzania",
  "IR": "Iran",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Wilayah Selatan dan Antartika Perancis",
  "PS": "Palestina",
  "SC": "Seychelles",
  "BT": "Bhutan",
  "JM": "Jamaika",
  "BR": "Brazil",
  "CH": "Swiss",
  "SH": "Saint Helena",
  "HU": "Hungary",
  "TM": "Turkmenistan",
  "LT": "Lithuania",
  "MC": "Monaco",
  "LI": "Liechtenstein",
  "LR": "Liberia",
  "GE": "Georgia",
  "SA": "Arab Saudi",
  "GB": "Inggris",
  "VE": "Venezuela",
  "MU": "Mauritius",
  "HR": "Kroasia",
  "SR": "Suriname",
  "CM": "Kamerun",
  "IQ": "Irak",
  "BO": "Bolivia",
  "MN": "Mongolia",
  "DZ": "Aljazair",
  "TK": "Tokelau",
  "MG": "Madagascar",
  "YT": "Mayotte",
  "CC": "Cocos Islands",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Qatar",
  "AN": "Netherlands Antilles",
  "PN": "Pitcairn Islands",
  "ES": "Spain",
  "VC": "Saint Vincent and the Grenadines",
  "AU": "Australia",
  "CX": "Christmas Island",
  "KM": "Comoros",
  "MR": "Mauritania",
  "FR": "France",
  "SG": "Singapore",
  "All_Country": "Semua",
  "BV": "Bouvet Island",
  "PH": "Philippines",
  "CY": "Cyprus",
  "TV": "Tuvalu",
  "CF": "Central African Republic",
  "EC": "Ecuador",
  "GW": "Guinea-Bissau",
  "IE": "Ireland",
  "LK": "Sri Lanka",
  "ER": "Eritrea",
  "GQ": "Equatorial Guinea",
  "NP": "Nepal",
  "BE": "Belgium",
  "GY": "Guyana",
  "DK": "Denmark",
  "MQ": "Martinique",
  "UZ": "Uzbekistan",
  "CI": "Côte d'Ivoire",
  "ID": "Indonesia",
  "BJ": "Benin",
  "ST": "Sao Tome and Principe",
  "KH": "Cambodia",
  "KZ": "Kazakhstan",
  "MS": "Montserrat",
  "TH": "Thailand",
  "FI": "Finland",
  "ML": "Mali",
  "AM": "Armenia",
  "IT": "Italia",
  "NR": "Nauru",
  "PG": "Papua New Guinea",
  "ZW": "Zimbabwe",
  "JO": "Jordan",
  "OM": "Oman",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "New Zealand",
  "VU": "Vanuatu",
  "DE": "Germany",
  "CZ": "Czech Republic",
  "DM": "Dominica",
  "KY": "Cayman Islands",
  "BW": "Botswana",
  "RO": "Romania",
  "PR": "Puerto Rico",
  "AZ": "Azerbaijan",
  "IO": "British Indian Ocean Territory",
  "UA": "Ukraine",
  "TG": "Togo",
  "MY": "Malaysia",
  "AG": "Antigua and Barbuda",
  "EG": "Egypt",
  "GS": "South Georgia and the South Sandwich Islands",
  "MM": "Myanmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "zhichiDeliveryCountry": "Hantar ke",
  "ShippingFee": "Yuran Penghantaran",
  "reviewOutOf": "{rating} bintang, daripada 5 bintang",
  "product.pifa.label": "Beli {startnum} - {endnum} unit",
  "product.pifa.type.1": "Diskaun",
  "Write_a_review": "Menulis ulasan",
  "BasedOnTotalReviews": "Berdasarkan {total} ulasan",
  "product.wholesale": "Harga borong",
  "reviewMostRecent": "Ulasan Terbaru",
  "product.pifa.type.2": "Harga seunit",
  "product.num.danwei": "unit",
  "good.shoppingDateLabel": "Tarikh Penghantaran",
  "good.shippingPeriod": "Hari Penghantaran",
  "emailError": "Format emel salah",
  "addressNote": "Nota Alamat",
  "Concactus": "Hubungi",
  "addressMessage": "Pastikan alamat anda betul. Selepas membuat bayaran, kami tidak dapat menukar alamat anda.",
  "showOrderSummary": "Ringkasan Pesanan",
  "payment_method": "Cara Pembayaran",
  "emailNotNullError": "E-mel tidak boleh kosong",
  "orderCreateLoading": "Pesanan sedang dicipta...",
  "emailNote": "Hubungi",
  "emailMessage": "Pastikan alamat e-mel anda betul. Kami akan menghantar pengesahan pesanan kepada anda.",
  "payment_method_message": "Semua transaksi adalah selamat dan dienkripsi.",
  "go_buy_goods": "Teruskan membeli-belah",
  "tap_cancel_order": "Klik di sini untuk membatalkan pesanan",
  "order_review": "Penilaian Pesanan",
  "Add_new_address": "Tambah alamat baru",
  "promo_code_type_3": "Kupon Hadiah Penuh",
  "IdCardNotNull": "Sila isi maklumat nama sebenar",
  "UploadVideo": "Muat naik video",
  "video": "Video",
  "UploadImage": "Muat naik gambar",
  "uploadImageing": "Sedang memuat naik...",
  "BillingInfoNotNull": "Maklumat bil tidak lengkap",
  "promo_code_type_2": "Kupon Tunai",
  "UploadError": "Muat naik gagal",
  "promo_code_type_4": "Kupon Kurang Kos Penghantaran",
  "image": "Gambar",
  "paymentMethodNotNull": "Sila pilih cara pembayaran",
  "promo_code_type_1": "Kupon Diskaun",
  "shippingInfoNotNull": "Maklumat penghantaran tidak lengkap",
  "reviewDetail": "Butiran penilaian",
  "DeliveryCountry": "Kawasan Penghantaran",
  "prompt_error": "Ralat petunjuk",
  "save_review_success": "Berjaya menilai",
  "ORDER_COMPLETED": "Telah Diselesaikan",
  "crate_after_sales": "Menyediakan Jualan Selepas",
  "Thank_You_Order": "Terima kasih kerana pesanan anda!",
  "Thank_You_Order_sub": "Tunggu kami proses pesanan anda. Anda akan menerima email mengenai pemprosesan pesanan anda.",
  "BootomCookieContext": "Laman ini menggunakan kuki untuk membantu laman web berfungsi dengan baik dan membantu kami memahami cara berinteraksi dengannya. Kami menggunakan kuki ini untuk memberi anda pengalaman penggunaan tersuai. Jika anda terus menggunakan laman ini, kami akan ",
  "order_reivice_message": "Adakah anda pasti bahawa anda telah menerima barangan?",
  "order_reivice_btn": "Menerima Pesanan",
  "order_reivice_label": "Penerimaan Pesanan",
  "order_reivice_success": "Berjaya Terima Pesanan",
  "collpase_show": "Lihat Lebih Banyak",
  "collpase_hide": "Tutup",
  "CouponCode": "kod kupon",
  "wechatPayScannerCode": "Sila gunakan WeChat untuk imbas bayaran kod",
  "processing": "Dalam Proses Selepas Jualan",
  "finished": "Selepas Jualan Telah Siap",
  "login.showPrice": "Lihat Harga Selepas Log Masuk",
  "After_Sales_Unknown": "Status Selepas Jualan Tidak Diketahui",
  "order_payment_list_null": "Tiada Pesanan yang Menunggu Pembayaran",
  "Cancel": "Batalkan",
  "thankyou_concat": "Sekiranya terdapat sebarang pertanyaan, sila hubungi kami"
}